import React from 'react';
import { Tooltip } from 'react-bootstrap';
import { LabelText } from '../../Language/LabelText';


export const changeRequestTooltip = (labelKey, additionalInfo) => {
    return (<Tooltip id={labelKey}>
                {additionalInfo && <span>{additionalInfo} </span>}<span><LabelText tid={labelKey} /></span> 
            </Tooltip>
    );
};

export const hiddenTooltip = (
    <div/>
);